<template>
  <div class="edit-main">
    <div class="page-contain view-meeting-plan">
        <el-form :model="addNewOrEditData" :show-message="false" ref="form" label-position="top">
            <div class="page-contain-tab">
                <div class="content-box">
                    <el-row>
                        <el-col>
                            <el-form-item required label="会议名称">
                                <label>{{addNewOrEditData.meetingName}}</label>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item required>
                                <span class="tooltip-header-text" slot="label">系统选择<common-tooltip tipCode="8"></common-tooltip></span>
                                <label>{{basedataGetName('MeetingSystem', addNewOrEditData.meetingSystem)}}</label>
                            </el-form-item>                            
                        </el-col>
                        <el-col>
                            <el-form-item required label="是否网络会议">
                                <label>{{basedataGetName('MeetingModality', addNewOrEditData.meetingModality)}}</label>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item required label="会议性质">
                                <label>{{basedataGetName('MeetingProp', addNewOrEditData.meetingProp)}}</label>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="meetingSystemType != 'GSD'">
                            <el-form-item required label="A1会议类型">
                                <label>{{basedataGetName('MeetingType', addNewOrEditData.meetingType)}}</label>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="addNewOrEditData.meetingType === '24' && isCEDepart()">
                            <el-form-item required label="是否为GSD" prop="isGsd">
                                <el-radio-group disabled v-model="addNewOrEditData.isGsd">
                                    <el-radio :label="1">是</el-radio>
                                    <el-radio :label="0">否</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="meetingSystemType != 'A1'">
                        <el-col>
                            <el-form-item required label="GSD项目类型">
                                <label>{{basedataGetName('MeetingGsdType', addNewOrEditData.meetingGsdType)}}</label>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item required label="GSD细类">
                                <label>{{basedataGetName('MeetingGsdTypeSub'+addNewOrEditData.meetingGsdType, addNewOrEditData.meetingGsdSubType)}}</label>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="page-contain-tab">
                <div class="content-box">
                    <el-row>
                        <el-col>
                            <el-form-item required label="部门">
                                <label>{{basedataGetName('Depart', addNewOrEditData.departId)}}</label>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item required label="Franchise/DA">
                                <label>{{basedataGetName('MedicalField', addNewOrEditData.medicalField)}}</label>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item required label="团队">
                                <label>{{basedataGetName('Teams', addNewOrEditData.teamL4)}}</label>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col v-if="basedataGetName('MeetingProp',addNewOrEditData.meetingProp) == '推广'">
                            <el-form-item required label="治疗领域">
                                <label>{{basedataGetName('TreatmentArea', addNewOrEditData.treatmentArea)}}</label>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="basedataGetName('MeetingProp',addNewOrEditData.meetingProp).indexOf('非推广') >= 0">
                            <el-form-item required label="疾病领域">
                                <label>{{basedataGetName('DiseaseArea', addNewOrEditData.diseaseArea)}}</label>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item required label="产品">
                                <label>{{basedataGetName('Product', addNewOrEditData.productId)}}</label>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item required label="公司战略">
                                <label>{{basedataGetName('CompanyStrategy', addNewOrEditData.companyStrategy)}}</label>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item required label="策略重点">
                                <label>{{addNewOrEditData.strategyKeynoteName}}</label>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item :required="meetingSystemType != 'A1'" :class="meetingSystemType != 'A1'?'':'not-required'" label="治疗领域业务结果">
                                <label>{{addNewOrEditData.medicalFieldResultName}}</label>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="addNewOrEditData.medicalFieldResult.join(',').indexOf('999999') >= 0">
                            <el-form-item class="not-required" label="治疗领域业务结果（自定义描述）">
                                <label>{{addNewOrEditData.medicalFieldResultDes}}</label>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="page-contain-tab">
                <div class="content-box">
                    <el-row>
                        <el-col>
                            <el-form-item required label="开始日期">
                                <label>{{addNewOrEditData.meetingBeginDate | DateFormat}}</label>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item required label="结束日期">
                                <label>{{addNewOrEditData.meetingEndDate | DateFormat}}</label>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item  :required="meetingSystemType != 'GSD'" :class="meetingSystemType != 'GSD'?'':'not-required'"  label="会议时段">
                                <label>{{basedataGetName('MeetingTimeInt', addNewOrEditData.meetingTimeInt)}}</label>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item :required="meetingSystemType != 'GSD'" :class="(meetingSystemType != 'GSD')?'':'not-required'" label="国家">
                                <label>{{addNewOrEditData.countryName}}</label>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item :required="meetingSystemType != 'GSD'" :class="(meetingSystemType != 'GSD')?'':'not-required'"  label="省份">
                                <label>{{addNewOrEditData.provinceName}}</label>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item :required="meetingSystemType != 'GSD'" :class="(meetingSystemType != 'GSD')?'':'not-required'"  label="城市">
                                <label>{{addNewOrEditData.cityName}}</label>
                            </el-form-item>
                        </el-col>                        
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item :required="meetingSystemType != 'GSD' && basedataGetName('MeetingModality',addNewOrEditData.meetingModality).indexOf('线下') >= 0" :class="(meetingSystemType != 'GSD' || basedataGetName('MeetingModality',addNewOrEditData.meetingModality).indexOf('线下') >= 0)?'':'not-required'"  label="会议地点">
                                <label>{{addNewOrEditData.meetingPlace}}</label>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="page-contain-tab">
                <div class="content-box">
                    <el-row v-if="meetingSystemType != 'A1'">
                        <div class="col-full">
                            <el-form-item required label="受赠方类型(GSD系统)">
                                <el-radio-group disabled v-model="recipientSocietyOrHospital">
                                    <el-radio :label="1" class="tooltip-header-text">受赠学会<common-tooltip tipCode="11"></common-tooltip></el-radio>
                                    <el-radio :label="0">医院</el-radio>
                                    <el-radio :label="2">大学</el-radio>
                                    <el-radio :label="3">患者组织</el-radio>
                                    <el-radio :label="4">其他</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>  
                    </el-row>
                    <el-row class="recipientSociety-input" v-if="meetingSystemType != 'A1' && recipientSocietyOrHospital">                        
                        <el-col>
                            <label>{{addNewOrEditData.recipientSocietyStr || addNewOrEditData.universityStr || addNewOrEditData.patientOrgStr || addNewOrEditData.otherStr}}</label>
                        </el-col>
                    </el-row>                      
                    <div v-if="meetingSystemType == 'A1' || !recipientSocietyOrHospital">
                        <el-row>
                            <el-col v-if="!isOneHospital()">
                                <el-form-item required label="医院总数">
                                    <el-radio-group disabled v-model="moreThenOneHospital">
                                        <el-radio :label="0">一家</el-radio>
                                        <el-radio :label="1">两家及以上</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>  
                        </el-row>
                        <el-row class="more-tab">
                            <el-col>
                                <el-form-item required prop="hospitalLevelId">
                                    <span class="tooltip-header-text" slot="label">医院层级<common-tooltip tipCode="9"></common-tooltip></span>
                                    <label>{{addNewOrEditData.hospitalLevelName}}</label>
                                </el-form-item>
                            </el-col>  
                            <el-col v-if="moreThenOneHospital && !isOneHospital()" class="col-add-remove">
                                <el-form-item required label="医院数量" :prop="'extendData.hospitalInfos.'+index+'.hospitalCount'">
                                    <label>{{addNewOrEditData.hospitalCount}}</label>
                                </el-form-item>                                
                            </el-col> 
                            <el-col v-else>
                                <el-form-item required label="医院" prop="hospitalId">
                                    <label>{{addNewOrEditData.hospitalName}}</label>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <div v-if="moreThenOneHospital && !isOneHospital()">
                            <div class="more-tab-div" v-for="(hospital,index) in addNewOrEditData.extendData.hospitalInfos" :key="index">
                                <el-row class="more-tab">
                                    <el-col>
                                        <el-form-item required :prop="'extendData.hospitalInfos.'+index+'.hospitalLevelId'">
                                            <span class="tooltip-header-text" slot="label">医院层级<common-tooltip tipCode="9"></common-tooltip></span>
                                            <label>{{hospital.hospitalLevelName }}</label>
                                        </el-form-item>
                                    </el-col> 
                                    <el-col class="col-add-remove">
                                        <el-form-item required label="医院数量" :prop="'extendData.hospitalInfos.'+index+'.hospitalCount'">
                                            <label>{{hospital.hospitalCount}}</label>
                                        </el-form-item>
                                    </el-col> 
                                </el-row>
                            </div>
                        </div>   
                        <el-row>
                            <el-col>
                                <el-form-item :required="meetingSystemType != 'GSD'" :class="meetingSystemType != 'GSD'?'':'not-required'" label="科室">
                                    <label>{{basedataGetName('Office', addNewOrEditData.offices)}}</label>
                                </el-form-item>
                            </el-col>  
                        </el-row>
                    </div>
                    <el-row>
                        <el-col>
                            <el-form-item required label="是否包含讲者">
                                <label>{{addNewOrEditData.includeSpeaker? '是' : '否'}}</label>
                            </el-form-item>
                        </el-col>  
                    </el-row>
                    <el-row class="more-tab" v-if="addNewOrEditData.includeSpeaker == 1">
                        <el-col>
                            <el-form-item :required="meetingSystemType != 'GSD'" :class="meetingSystemType != 'GSD'?'':'not-required'">
                                <span class="tooltip-header-text" slot="label">讲者级别<common-tooltip tipCode="10"></common-tooltip></span>
                                <label>{{addNewOrEditData.speakerLevelName}}</label>
                            </el-form-item>
                        </el-col>  
                        <el-col class="col-add-remove">
                            <el-form-item :required="meetingSystemType != 'GSD'" :class="meetingSystemType != 'GSD'?'':'not-required'" label="讲者人数">
                                <label>{{addNewOrEditData.speakerCount}}</label>
                            </el-form-item>
                        </el-col> 
                    </el-row>
                    <div class="more-tab-div" v-if="addNewOrEditData.includeSpeaker == 1">
                        <el-row class="more-tab" v-for="(speaker,index) in addNewOrEditData.extendData.speakerInfos" :key="index">
                            <el-col>
                                <el-form-item :required="meetingSystemType != 'GSD'" :class="meetingSystemType != 'GSD'?'':'not-required'">
                                    <span class="tooltip-header-text" slot="label">讲者级别<common-tooltip tipCode="10"></common-tooltip></span>
                                    <label>{{speaker.speakerLevelName}}</label>
                                </el-form-item>
                            </el-col>  
                            <el-col class="col-add-remove">
                                <el-form-item :required="meetingSystemType != 'GSD'" :class="meetingSystemType != 'GSD'?'':'not-required'" label="讲者人数">
                                    <label>{{speaker.speakerCount}}</label>
                                </el-form-item>
                            </el-col> 
                        </el-row>
                    </div>
                    <el-row>
                        <el-col>
                            <el-form-item required label="参会人数（外）">
                                <label>{{addNewOrEditData.attendCount}}</label>
                            </el-form-item>
                        </el-col>  
                        <el-col>
                            <el-form-item :required="meetingSystemType != 'GSD'" :class="meetingSystemType != 'GSD'?'':'not-required'" label="罗氏员工人数（内）">
                                <label>{{addNewOrEditData.rocheCount}}</label>
                            </el-form-item>
                        </el-col> 
                    </el-row>
                </div>
            </div>
            <div class="page-contain-tab">
                <div class="content-box">
                    <el-row> 
                        <el-col>
                            <el-form-item required >
                                <span class="tooltip-header-text" slot="label">会议总预算<common-tooltip tipCode="12"></common-tooltip></span>
                                <label>{{addNewOrEditData.totalAmount}}</label>
                            </el-form-item>
                        </el-col> 
                        <el-col>
                            <el-form-item required label="成本中心">
                                <label>{{addNewOrEditData.costCenter+' '+addNewOrEditData.costCenterName}}</label>
                            </el-form-item>
                        </el-col>  
                        <el-col>
                            <el-form-item class="not-required" label="WBS code">
                                <label>{{addNewOrEditData.wbsCode}}</label>
                            </el-form-item>
                        </el-col> 
                    </el-row>
                    <el-row> 
                        <el-col v-if="addNewOrEditData.meetingSystem.length == 2">
                            <el-form-item required label="A1预算">
                                <label>{{addNewOrEditData.a1Amount}}</label>
                            </el-form-item>
                        </el-col> 
                        <el-col v-if="addNewOrEditData.meetingSystem.length == 2">
                            <el-form-item required label="GSD预算">
                                <label>{{addNewOrEditData.gsdAmount}}</label>
                            </el-form-item>
                        </el-col> 
                        <el-col>
                            <el-form-item  class="not-required" label="会议申请人">
                                <label>{{addNewOrEditData.meetingOrganizerCnname + ' ' + addNewOrEditData.meetingOrganizerName}}</label>
                            </el-form-item>
                        </el-col> 
                    </el-row>
                </div>
            </div>
            
            <div class="page-contain-tab">
                <div class="approval-workflow-title">
                    审批流
                    <div></div>
                </div>
                <div class="content-box">
                    <el-row v-for="node in addNewOrEditData.nodeList" :key="node.id"> 
                        <el-col class="approval-workflow">
                            <el-form-item  class="not-required" :label="node.isAuthorized === 0 ? node.nodeLevel + '【授权审批】' : node.nodeLevel" prop="treatAreaResult">
                                <label>{{node.realName}} {{node.username}} {{node.createTime}} {{node.isAuthorized === 0 ? `（${node.licensorName}授权）` : ''}}</label>
                                <span :class="['approval-status', approvalStatusClass(node.meetStatus)]">{{node.statusName}}</span>
                            </el-form-item>                            
                            <el-form-item v-if="node.remark"  class="not-required">
                                <label>{{node.remark}}</label>
                            </el-form-item>
                        </el-col>
                    </el-row>                    
                </div>
            </div>
        </el-form>
    </div>
    <div v-if="(addNewOrEditData.status == '5' || addNewOrEditData.status == '8') && addNewOrEditData.isAutoReject !== '1'" class="bottom-info">
      <div class="bottom-info-operate">
        <!-- <el-button plain @click="handleCancleClick" >取消</el-button> -->
        <el-button type="primary" @click="handlerChangeClick">变更</el-button>
      </div>
    </div>
    <!-- 确认变更 -->
    <common-confirm :dialogVisiable.sync="confirmChangeVisible" :confirm="handlerChangeConfirmOK">
        <div>
            确认变更会议？
        </div>
    </common-confirm>
    <!-- 确认取消 -->
    <common-confirm :dialogVisiable.sync="confirmCancleVisible" :confirm="handlerCancleConfirmOK">
        <div>
            确认取消会议？
        </div>
        <div class="cancle-alert-info">
            （确认取消后将无法恢复）
        </div>
    </common-confirm>
  </div>
</template>

<script>
import application from '@/api/meetingplan/application';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      addNewOrEditData: {
          meetingName: '',
          meetingType: '',
          meetingGsdType: '',
          meetingGsdSubType: '',
          meetingProp: '',
          meetingModality: '',
          meetingSystem: [],
          departId: '',
          medicalField: '',
          treatmentArea: '',
          diseaseArea: '',
          productId: [],
          companyStrategy: [],
          strategyKeynote: [],
          medicalFieldResult: [],
          medicalFieldResultDes: '',
          meetingBeginDate: '',
          meetingEndDate: '',
          meetingTimeInt: '',
          country: '',
          province: '',
          city: '',
          meetingPlace: '',
          hospitalLevelId: '',
          hospitalCount: '',
          hospitalName: '',
          recipientSociety: '',
          universityStr: '',
          patientOrgStr: '',
          otherStr: '',
          offices: [],
          speakerLevel: '',
          speakerCount: '',
          attendCount: '',
          rocheCount: '',
          totalAmount: '',
          costCenter: '',
          wbsCode: '',
          a1Amount: '',
          gsdAmount: '',
          meetingOrganizer: '',
          includeSpeaker: '',
            extendData:{
                hospitalInfos: [],
                speakerInfos: [],
            },
        isAutoReject: '0'
      },
      confirmChangeVisible: false,
      confirmCancleVisible: false,
      recipientSocietyOrHospital: 1,
      moreThenOneHospital: 0,
    }
  },
  computed: {
    ...mapGetters(['baseDataRecords','basedataGetName','basedataGetIdByName','basedataGetObject']),
    MeetingGsdSubTypes() {
        return 'MeetingGsdTypeSub'+this.addNewOrEditData.meetingGsdType;
    },
    meetingSystemType() {
        //GSD、A1、All、None
        if(this.addNewOrEditData.meetingSystem.length == 0) {
            return 'None';
        }
        if(this.addNewOrEditData.meetingSystem.length == 2) {
            return 'All';
        }
        if(this.addNewOrEditData.meetingSystem.length == 1) {
            return this.basedataGetName('MeetingSystem',this.addNewOrEditData.meetingSystem)
        }
    },
  },
  methods: {
    ...mapActions(['initBaseDataByTypes']),
    approvalStatusClass(status) {
        switch (status) {
            case '2':                
                return 'approval-submit' 
            case '3':                
                return 'approval-padding'                
            case '4':                
                return 'approval-comfirm'              
            case '5':                
                return 'approval-reject'              
            case '7':                
                return 'approval-cancle'
        }
        return ''
    },
    showHospitalName(hospitalObj) {
        return hospitalObj.hospitalCount == 1 || 
                this.basedataGetName('MeetingType',this.addNewOrEditData.meetingType) == '科室会' || 
                this.basedataGetName('MeetingType',this.addNewOrEditData.meetingType) == '院内会';
    },
    handleCancleClick() {
        this.confirmCancleVisible = true;
    },
    handlerCancleConfirmOK() {
        application.cancle({id:this.addNewOrEditData.id})
                    .then(res => {
                        history.back();
                    });
    },
    handlerChangeClick() {
        this.confirmChangeVisible = true;
    },
    handlerChangeConfirmOK() {
        this.$router.push({
            name: 'meetingplan-application-change',
            params: {'id':this.addNewOrEditData.id}
        }); 
    }, 
    isOneHospital(hospitalObj) {
        return this.basedataGetName('MeetingType',this.addNewOrEditData.meetingType) == '科室会' || 
                this.basedataGetName('MeetingType',this.addNewOrEditData.meetingType) == '院内会';
    },
    isCEDepart() {
      return this.addNewOrEditData.departId === 'CE-OMNI' || this.addNewOrEditData.departId === 'CE-ONCO';
    },
  },  
  mounted() {   
     this.initBaseDataByTypes(['MeetingType','MeetingProp','MeetingModality','MeetingSystem','Depart','MedicalField','TreatmentArea','DiseaseArea','Product','CompanyStrategy','MeetingTimeInt','Country','Office','CostCenter','WbsCode','MeetingGsdType','MeetingGsdTypeSub1','MeetingGsdTypeSub2','MeetingGsdTypeSub3'])
        .then(() => {
            application.queryById({id:this.$route.params.id})
                .then(res => {
                    //转换多选项
                    res.companyStrategy = res.companyStrategy.split(',');
                    res.medicalFieldResult = res.medicalFieldResult == null ? ''.split(',') : res.medicalFieldResult.split(',');
                    res.meetingSystem = res.meetingSystem.split(',');
                    res.offices = res.offices == null ? '' : res.offices.split(',');
                    res.productId = res.productId.split(',');
                    res.strategyKeynote = res.strategyKeynote.split(',');

                    //新需求字段初始化
                    res.meetingGsdType = res.meetingGsdType || '';
                    res.meetingGsdSubType = res.meetingGsdSubType || '';
                    res.universityStr = res.universityStr || '';
                    res.patientOrgStr = res.patientOrgStr || '';
                    res.otherStr = res.otherStr || '';
                    res.teamL4 = res.teamL4 || '';
                    
                    res.extendData = {
                        hospitalInfos:[],
                        speakerInfos:[],
                    };
                    //转换医院信息
                    if(res.pubMeetingHospitalLevelList.length > 0) {
                        res.hospitalLevelId = res.pubMeetingHospitalLevelList[0].hospitalLevelId;
                        res.hospitalLevelName = res.pubMeetingHospitalLevelList[0].hospitalLevelName;
                        res.hospitalCount = res.pubMeetingHospitalLevelList[0].count;
                        res.hospitalName = res.pubMeetingHospitalLevelList[0].hospitalName;
                        res.recipientSociety = res.pubMeetingHospitalLevelList[0].recipientSociety;
                    }
                    if(res.pubMeetingHospitalLevelList.length > 1) {
                        for (let index = 1; index < res.pubMeetingHospitalLevelList.length; index++) {
                            const element = res.pubMeetingHospitalLevelList[index];

                            res.extendData.hospitalInfos.push({
                                hospitalLevelId : element.hospitalLevelId,
                                hospitalLevelName : element.hospitalLevelName,
                                hospitalCount : element.count,
                                hospitalName : element.hospitalName,
                                recipientSociety : element.recipientSociety,
                            })
                        }
                    }
                    res.pubMeetingHospitalLevelList = '';

                    //转换讲者信息
                    res.includeSpeaker = res.pubMeetingSpeakerLevelList.length > 0? 1 :0;
                    if(res.pubMeetingSpeakerLevelList.length > 0) {
                        res.speakerLevel = res.pubMeetingSpeakerLevelList[0].speakerLevel;
                        res.speakerLevelName = res.pubMeetingSpeakerLevelList[0].speakerLevelName;
                        res.speakerCount = res.pubMeetingSpeakerLevelList[0].count;
                    }
                    if(res.pubMeetingSpeakerLevelList.length > 1) {
                        for (let index = 1; index < res.pubMeetingSpeakerLevelList.length; index++) {
                            const element = res.pubMeetingSpeakerLevelList[index];

                            res.extendData.speakerInfos.push({
                                speakerLevel : element.speakerLevel,
                                speakerLevelName : element.speakerLevelName,
                                speakerCount : element.count,
                            })
                        }
                    }
                    if(res.extendData.hospitalInfos.length > 0) {
                        this.recipientSocietyOrHospital = 0;
                        this.moreThenOneHospital = 1;
                    }
                    else {
                        if(res.hospitalId || res.hospitalCount > 0) {
                            if(res.hospitalCount > 1) {
                                this.recipientSocietyOrHospital = 0;
                                this.moreThenOneHospital = 1;
                            }
                            else {
                                this.recipientSocietyOrHospital = 0;
                                this.moreThenOneHospital = 0;                                        
                            }
                        }
                        else {
                            if(res.recipientSocietyStr) {
                                this.recipientSocietyOrHospital = 1;
                            }
                            if(res.universityStr) {
                                this.recipientSocietyOrHospital = 2;
                            }
                            if(res.patientOrgStr) {
                                this.recipientSocietyOrHospital = 3;
                            }
                            if(res.otherStr) {
                                this.recipientSocietyOrHospital = 4;
                            }
                            this.moreThenOneHospital = 0;
                        }
                    }
                    res.pubMeetingSpeakerLevelList = '';

                    this.addNewOrEditData = res;
                })
        })    
  }
};
</script>

<style lang="less" scoped>
.page-contain {
  
  .page-contain-tab {
    padding: 0 56px 32px 56px;
    margin-bottom: 24px;

    .recipientSocietyOrHospital-text span{
        color: @mainColor;
    }

    .recipientSociety-input {
        font-size: 14px;
        margin-left: 10px;
        padding-top: 8px !important;
    }

    .more-tab {
        background: #F6F6F6;
        border-radius: 2px;
        width: 784px;
        margin-top: 8px !important;
        margin-left: -16px !important;
        padding-left: 16px !important;
        padding-top: 16px !important;
        padding-bottom: 12px !important;
    }

    .more-tab-div{
        margin-top: 16px;
    }
  }

    .approval-workflow {
        width: auto !important;
    }

    .approval-workflow-title {
        font-size: 14px;
        margin-left: 10px;
        padding-top: 24px;

        div {
            border-top: 1px solid #E8E8E8;
            margin: 24px -56px 0 -66px;
        }
    }

    .approval-status {
        margin-left: 20px;
        padding: 5px;
        border-radius: 2px;
        height: 22px;
        font-size: 12px;
    }

    .approval-padding {
        border: 1px solid #FFDA95;
        background-color: #FFF8EA;
        color: #FFB52A;
    }

    .approval-comfirm {
        border: 1px solid #8BE9BE;
        background-color: #EDFFF6;
        color: #0EC771;
    }

    .approval-reject {
        border: 1px solid #FF9CAA;
        background-color: #FFEFF1;
        color: #FB304D;
    }

    .approval-cancle {
        border: 1px solid #D6D6D6;
        background-color: #F6F6F6;
        color: #666666;
    }

    .approval-submit {
        border: 1px solid #A2CBFF;
        background-color: #EBF4FF;
        color: #2D82F0;
    }
}  

.bottom-info {
    display: flex;
    position: fixed;
    background-color: #fff;
    width: 100%;
    left: 0;
    height: 44px;
    box-shadow: -1px 0px 4px 0px rgba(51,51,51,0.35); 
    bottom: 0;

    &-info {
      margin-left: 120px;
      line-height: 44px;
    }

    &-operate {
      position: absolute;
      right: 120px;
      line-height: 46px;
    }
  }

  .col-add-remove {
      display: flex;
  }

  .operate-add-remove {
    display: flex;
    font-size: 20px;
    margin: 38px 0px 0px 10px;

    span {
        cursor: pointer;
    }

    span + span {
        margin-left: 10px;
    }
  }

  
.view-meeting-plan {
    padding: 0;
    margin-bottom: 85px;

    .edit-form-title {
        padding: 26px 0 0 34px;
        color: #0066CC;
        font-size: @subFontSize;
        display: block;
    }

    .el-form.el-form--label-top{
        .el-row {
            padding: 24px 0 0 0;

            .col-full {
                width: 1088px;

                .el-input__inner {
                    width: 1088px;
                }

                .el-textarea__inner {
                    height: 110px;
                }

                .el-form-item__label {
                    height: 24px;
                    line-height: 24px;
                    color: @contentFontColor;
                    font-size: @contentFontSize;
                }

                .el-form-item__content {
                    padding-top: 2px;

                    label {
                        margin-left: 10px;
                    }
                }
            }

            .el-col {
                width: 320px;

                .el-form-item__label {
                    height: 24px;
                    line-height: 24px;
                    color: @contentFontColor;
                    font-size: @contentFontSize;
                }

                .el-form-item__content {
                    padding-top: 2px;

                    .el-select, .el-input {
                        width: 320px;
                    }

                    label {
                        margin-left: 10px;
                    }
                }
            }

            .el-col  + .el-col {
                margin-left: 64px;
            }
        }

        .col-no-3 {
            margin-left: 768px;
        }
    }

    .el-form.el-form--label-right{
        .el-row {
        padding: 21px 34px 0 34px;
        }
    }
}

.cancle-alert-info {
    margin-top: 6px;
}
</style>



// WEBPACK FOOTER //
// index.vue?2248981e